import { defaultImage, Media, Selector, Video } from '@/hub-shared'
import React from 'react'
import './selector-image.component.scss'

interface SelectorProps extends React.HTMLAttributes<HTMLDivElement> {
  index: string | number
  name?: string
  media?: Media | Video
  checked?: boolean
  mediaTitle: string
  mediaURL: string
  hasLabel: boolean
  hasBorder?: boolean
  maxHeight?: boolean
  onChange?: (event: any) => any
}

const SelectorImage = ({
  index,
  name,
  media,
  checked,
  mediaTitle,
  mediaURL,
  onChange,
  hasLabel = false,
  hasBorder = false,
  maxHeight = false,
}: SelectorProps) => {
  const timestamp = `random-id-${(1 + Date.now() + Math.random()).toString().replace('.', '')}`

  return (
    <Selector
      name={`${name || timestamp}-checkbox`}
      id={`${name || timestamp}-checkbox-${index}`}
      key={`${name || timestamp}-checkbox-${index}`}
      className={`modal-select-video-item ${maxHeight ? 'max-height' : ''}`}
      hideInput
      type="radio"
      errorSpan={false}
      value={media}
      checked={checked}
      onChange={() => onChange(media)}
      leftLabel={
        <div className={hasBorder ? 'box-border' : ''}>
          <figure className={checked ? 'checked' : ''}>
            <img
              className="img-fluid"
              alt={mediaTitle}
              src={mediaURL}
              title={mediaTitle}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null
                currentTarget.src = defaultImage
              }}
              loading="lazy"
            />
            <span className="radio-custom"></span>
            {hasLabel ? <label className="mt-1">{mediaTitle}</label> : null}
          </figure>
        </div>
      }
    />
  )
}
export default SelectorImage
